
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cart/[id]",
      function () {
        return require("private-next-pages/cart/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cart/[id]"])
      });
    }
  